module.exports = __webpack_public_path__ + "resources/img/img_maxgauge1.34ce494f6af69859ade32fb45761f7ca.png";